import * as React from 'react'
import { RouteComponentProps } from 'react-router-dom'
import { IDriverSearchObject, IActiveTripResponseV2, ISimpleDriverDTO, IVehicleFilters, IVehicleObj } from 'src/types'
import { off, title } from 'process'
import { MoonLoader } from 'react-spinners'
import Modal from 'src/components/ui/Modal'
import UIMessages from 'src/utils/ui-messages'
import { Select } from '@mobiscroll/react-latest'

interface IAssignOperatorVehicleProps extends RouteComponentProps {
  operatorId: string
  isFetching: boolean
  currentOrganizationId: string
  vehicles: IVehicleObj[]
  filters: IVehicleFilters
  onClose: () => void
  fetchAllVehicles: (params: IVehicleFilters) => Promise<any>
  assignDriver: (vehicleId: string, operatorId: string, params: IVehicleFilters) => Promise<any>
}

interface ISelectOption {
  text: string
  value: string
}
const AssignOperatorVehicle = (props: IAssignOperatorVehicleProps) => {
  const [vehicleOptions, setVehicleOptions] = React.useState<ISelectOption[]>([])
  const [selectedVehicle, setSelectedVehicle] = React.useState<ISelectOption>({ text: '', value: '' })
  const vehicleFilters: IVehicleFilters = {
    organizationId: props.currentOrganizationId,
    type: 'active',
    take: 100,
    recordsPerPage: 100,
    page: 0,
    unassigned: true
  }
  const onChange = (option: any) => {
    setSelectedVehicle(option)
  }
  const assignDriver = () => {
    if (selectedVehicle.value.length === 36) {
      props.assignDriver(selectedVehicle.value, props.operatorId, props.filters)
      props.onClose()
    }
  }

  React.useEffect(() => {
    props.fetchAllVehicles(vehicleFilters)
  }, [])
  React.useEffect(() => {
    if (props.vehicles) {
      const vehicles = props.vehicles.map(vehicle => {
        return { text: vehicle.licensePlate, value: vehicle.id }
      })
      setVehicleOptions(vehicles)
    }
  }, [props.vehicles])
  const vehicleSearch = (options: any) => {
    props.fetchAllVehicles({
      ...vehicleFilters,
      search: options
    })
  }
  return (
    <Modal>
      <div className='fixed top-0 bottom-0 left-0 right-0 flex justify-center items-center'>
        <div className='med-modal'>
          <span className='ModalAddTitle font-small weight-300 font-grey2 uppercase'>
            {UIMessages.trip.assign} Vehicle
          </span>
          <div className='mt1 border-top pt2'>
            <div className='mb1 mt1'>
              <Select
                name='SelectOperator'
                clearable={false}
                value={selectedVehicle.text}
                onChange={onChange}
                filter={true}
                data={vehicleOptions}
                touchUi={false}
                theme='ios'
                themeVariant='light'
                inputStyle='box'
                label={'Vehicle'}
                labelStyle='floating'
              />
            </div>
            {/* <div>{this.state.error.length ? <p className='font-red m0'>{this.state.error}</p> : null}</div> */}
          </div>
          {props.isFetching === true ? (
            <MoonLoader sizeUnit={'px'} size={20} color={'#405264'} loading={true} />
          ) : (
            <div className='flex items-center justify-end mt3'>
              <button
                type='button'
                onClick={props.onClose}
                disabled={props.isFetching}
                className='custom-btn mbsc-clear-btn mr2'
              >
                {UIMessages.common.cancel}
              </button>
              <div title={title} className='ml1 cursor--pointer'>
                <button
                  type='button'
                  onClick={assignDriver}
                  disabled={props.isFetching}
                  className='SubmitButton custom-btn mbsc-green-btn'
                >
                  {UIMessages.trip.assign}
                </button>
              </div>
            </div>
          )}
        </div>
      </div>
    </Modal>
  )
}

export default AssignOperatorVehicle



// WEBPACK FOOTER //
// ./src/components/drivers/AssignOperatorVehicle.tsx